import { UserClustersFragment, UserElementsFragment } from "@/core/graphql/graphql";
import { Column, ColumnType } from "@/shared/components/table/table.model";
import { extractProperty } from "@/utils/extract-property";
import { TemplateRef } from "@angular/core";

export const USER_CLUSTERS_COLUMNS: (imageCellTemplateReference: TemplateRef<any>, checkboxTemplateReference: TemplateRef<any>) =>
  Column<UserClustersFragment>[] = (imageCellTemplate: TemplateRef<any>, checkboxTemplate: TemplateRef<any>) => [
    {
      columnId: 'ID',
      caption: 'ID',
      fieldSelector: (obj) => extractProperty(obj.id),
    },
    {
      columnId: 'Name',
      caption: 'Name',
      fieldSelector: (obj) => extractProperty(obj.name),
    },
    {
      columnId: 'Is Private',
      caption: 'Is private',
      fieldSelector: (obj) => extractProperty(obj.isPrivate) ? 'Private' : 'Public',
    },
    {
      columnId: 'Followers',
      caption: 'Followers',
      fieldSelector: (obj) => extractProperty(obj.followersCount),
    },
    {
      columnId: 'Is Featured',
      caption: 'Is featured',
      fieldSelector: (obj) => extractProperty(obj),
      type: ColumnType.Template,
      template: checkboxTemplate,
    },
    {
      columnId: 'Cover Image',
      caption: 'Cover Image',
      fieldSelector: (obj) => extractProperty(obj),
      type: ColumnType.Template,
      template: imageCellTemplate,
    },
  ];
